module.exports = __webpack_public_path__ + "static/media/pokemon.1e9069d1.png";